import React, { FunctionComponent, PropsWithChildren } from 'react'
import { useCheckoutSummaryRouteGuard } from './hooks'

export const SummaryRouteGuard: FunctionComponent<PropsWithChildren> = ({ children }) => {
  useCheckoutSummaryRouteGuard()

  return <>{children}</>
}
